import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TaskRequestorLookupComponent } from './task-requestor-lookup.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule
    ],
    declarations: [TaskRequestorLookupComponent],
    exports: [TaskRequestorLookupComponent]
})
export class TaskRequestorLookupModule { }
